/**
 * Ambient scan sonar overlay — currently fully disabled (no vertical rails,
 * no horizontal sweep). Kept as a no-op mount so call sites stay stable.
 *
 * @param {{ active?: boolean }} props
 */
export default function ScanRadarOverlay({ active = false }) {
  if (!active) return null;
  return null;
}
